import { GenericHashArraysStoreFactory } from "../../../Common/_generics/GenericHashArraysStoreFactory";

export const BaseInvitationGroupsStore = GenericHashArraysStoreFactory("INVITATION_GROUPS", "uid");